import { fromJS } from 'immutable';

import baseReducer from 'redux/baseReducer';
import { createSymbols } from 'utils/helpers';

const initialState = fromJS({
    dates: [],
    disabledDates: [],
    hasFetched: false,
    hasPurchased: false,
    isCancelling: false,
    isFetchingCalendar: false,
    isFetchingQuote: false,
    isPurchasing: false,
    quote: null,
});

export const {
    ADD_FEATURE,
    ADD_FEATURE_FAIL,
    ADD_FEATURE_SUCCESS,
    CANCEL_FEATURE,
    CANCEL_FEATURE_FAIL,
    CANCEL_FEATURE_SUCCESS,
    EDIT_IN_FEATURED,
    FETCH_CALENDAR,
    FETCH_CALENDAR_FAIL,
    FETCH_CALENDAR_SUCCESS,
    FETCH_QUOTE,
    FETCH_QUOTE_FAIL,
    FETCH_QUOTE_SUCCESS,
    PURCHASE_DATES,
    PURCHASE_DATES_FAIL,
    PURCHASE_DATES_SUCCESS,
} = createSymbols([
    'ADD_FEATURE',
    'ADD_FEATURE_FAIL',
    'ADD_FEATURE_SUCCESS',
    'CANCEL_FEATURE',
    'CANCEL_FEATURE_FAIL',
    'CANCEL_FEATURE_SUCCESS',
    'EDIT_IN_FEATURED',
    'FETCH_CALENDAR',
    'FETCH_CALENDAR_FAIL',
    'FETCH_CALENDAR_SUCCESS',
    'FETCH_QUOTE',
    'FETCH_QUOTE_FAIL',
    'FETCH_QUOTE_SUCCESS',
    'PURCHASE_DATES',
    'PURCHASE_DATES_FAIL',
    'PURCHASE_DATES_SUCCESS',
]);

const cancelFeature = (state) => state.set('isCancellingFeature', true);
const cancelComplete = (state) => state.set('isCancellingFeature', false);
const editInFeatured = (state, { path, value }) => state.setIn(path, value);
const fetchCalendar = (state) => state.set('isFetchingCalendar', true);
const fetchCalendarFail = (state) => state.set('isFetchingCalendar', false);
const fetchCalendarSuccess = (state, action) => state.withMutations((prevState) => {
    prevState.set('isFetching', false)
        .set('hasFetched', true)
        .set('disabledDates', fromJS(action.payload.data));
});
const fetchQuote = (state) => state.set('isFetchingQuote', true);
const fetchQuoteFail = (state) => state.set('isFetchingQuote', false);
const fetchQuoteSuccess = (state, action) => state
    .set('isFetchingQuote', false)
    .set('quote', fromJS(action.payload.data.quote));
const purchaseDates = (state) => state.set('isPurchasing', true);
const purchaseDatesFail = (state) => state.set('isPurchasing', false);
const purchaseDatesSuccess = (state) => state
    .set('isPurchasing', false)
    .set('hasPurchased', true);

export default baseReducer(initialState, {
    [CANCEL_FEATURE]: cancelFeature,
    [CANCEL_FEATURE_FAIL]: cancelComplete,
    [CANCEL_FEATURE_SUCCESS]: cancelComplete,
    [EDIT_IN_FEATURED]: editInFeatured,
    [FETCH_CALENDAR]: fetchCalendar,
    [FETCH_CALENDAR_FAIL]: fetchCalendarFail,
    [FETCH_CALENDAR_SUCCESS]: fetchCalendarSuccess,
    [FETCH_QUOTE]: fetchQuote,
    [FETCH_QUOTE_FAIL]: fetchQuoteFail,
    [FETCH_QUOTE_SUCCESS]: fetchQuoteSuccess,
    [PURCHASE_DATES]: purchaseDates,
    [PURCHASE_DATES_FAIL]: purchaseDatesFail,
    [PURCHASE_DATES_SUCCESS]: purchaseDatesSuccess,
});
